import { render, staticRenderFns } from "./UploadShipper.vue?vue&type=template&id=5fae47ce&scoped=true&lang=pug&"
import script from "./UploadShipper.vue?vue&type=script&lang=ts&"
export * from "./UploadShipper.vue?vue&type=script&lang=ts&"
import style0 from "./UploadShipper.vue?vue&type=style&index=0&id=5fae47ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae47ce",
  null
  
)

export default component.exports